// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--PAz+u";
export var share = "styles-module--share--blpDk";
export var link = "styles-module--link--wNcHG";